module.exports = __webpack_public_path__ + "static/img/rwm.8230f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/rwm.png
// module id = R8l8
// module chunks = 2